export default "__VITE_ASSET__DO5uLoR3__"